import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img from "./img/img.png";

export const MythOfSteps = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>The myth of 10,000 steps </h4>
          <br />
          Learn to perform low-intensity, effective workouts and stretches to
          <strong> reduce back, neck and shoulder tension</strong>, while supporting joint
          mobility.
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
